import React from 'react';
import styles from './BackButton.module.scss';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { connect } from 'react-redux';

//redux stuff
import { previousActiveStep } from '../../../redux/agreement/actions';

const BackButton = ({ previousActiveStep, delay }) => {

	const handleClick = async () => {
		if (delay) {
			await new Promise(r => setTimeout(r, 1000));
		}
		previousActiveStep();
	};
	return (
		<div className={styles.backButton} onClick={handleClick}>
			<ArrowBackIosIcon /> Back
		</div>
	);
};

export default connect(null, { previousActiveStep })(BackButton);
